<template>
  <el-dialog
    title="Edit Owner"
    :visible.sync="dialogVisible"
    width="50%"
    @close="closeDialog"
  >
    <div v-if="providerCode === 'gapps'">
      <class-head :selectedClass="selectedClass" :owner="owner" />
    </div>
    <div v-else>
      <group-head :selectedClass="selectedClass" :owner="owner" />
    </div>
    <el-table class="custom-table overflow" :data="membersFiltered">
      <el-table-column prop="name" label="Name">
        <template slot-scope="scope">
          <span>{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="email" label="Email">
        <template slot-scope="scope">
          <span>{{ scope.row.emailAddress || 'NO EMAIL' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="isOwner" label="Ownership">
        <template slot-scope="scope">
          <span v-if="scope.row.isOwner && providerCode == 'gapps'">{{ 'Owner' }}</span>
          <div v-else-if="ownerIds.includes(scope.row.id) && providerCode == 'msft'">
            <el-button type="danger" :loading="loading" @click="removeOwner(scope.row.id)">
              Remove as owner
            </el-button>
          </div>
          <div v-else>
            <el-button type="primary" :loading="loading" @click="setOwner(scope.row.id)">
              Set as owner
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">Close</el-button>
    </span>
  </el-dialog>
</template>

<script>
import ClassHead from "../../classroom/google/ClassHead.vue";
import GroupHead from "../../classroom/microsoft/GroupHead.vue";
import gql from "graphql-tag";

const UPDATE_THIRD_PARTY_CLASS = gql`
	mutation UpdateThirdPartyClass($classId: String!, $properties: ClassProperties!) {
		UpdateThirdPartyClass(data: { classId: $classId, properties: $properties }) {
			id
			ownerId
		}
	}
`;

export default {
  props: {
    isDialogVisible: {
      type: Boolean,
      required: true
    },
    members: {
      type: Array,
      required: false
    },
    selectedClass: {
      type: Object,
      required: true
    }
  },
  components: {
    ClassHead,
    GroupHead
  },
  data() {
    return {
      dialogVisible: this.isDialogVisible,
      loading: false,
      thirdPartyClassOwner: null,
    };
  },
  watch: {
    isDialogVisible(newVal) {
      this.dialogVisible = newVal;
    }
  },
  computed: {
		owner() {
      return _(this.membersFiltered)
        .filter((member) => {
          return (!_.isEmpty(this.thirdPartyClassOwner) && this.thirdPartyClassOwner.split(",").includes(member.id));
        })
        .map((member) => member.name)
        .value();
		},
    ownerIds() {
      return _(this.members)
        .filter((member) => {
          return (!_.isEmpty(this.thirdPartyClassOwner) && this.thirdPartyClassOwner.split(",").includes(member.id));
        })
        .map((member) => member.id)
        .value()
    },
    membersFiltered() {
      return _(this.members)
        .uniqBy("id")
        .value();
    }
  },
  methods: {
    closeDialog() {
      this.$emit("close-members-dialog");
      this.dialogVisible = false;
    },
    setOwner(id) {
			this.loading = true;
			this.$apollo
				.mutate({
					mutation: UPDATE_THIRD_PARTY_CLASS,
					variables: {
						classId: this.selectedClass.id,
						properties: {
							ownerId: id,
						}
					},
				})
				.then((r) => {
					this.loading = false;
					this.$message.success("Owner updated");
				})
				.catch((e) => {
					this.loading = false;
					this.$message.error("Failed to update class ownership");
				});
		},
		removeOwner(id) {
			this.loading = true;
			this.$apollo
				.mutate({
					mutation: UPDATE_THIRD_PARTY_CLASS,
					variables: {
						classId: this.selectedClass.id,
						properties: {
							removeOwnerId: id,
						}
					},
				})
				.then((r) => {
					this.loading = false;
					this.$message.success("Owner updated");
				})
				.catch((e) => {
					this.loading = false;
					this.$message.error("Failed to update class ownership");
				});
		},
  },
  apollo: {
		thirdPartyClassOwner: {
			query: gql`
				query ThirdPartyClass($classId: String!, $members: [String!]!) {
					ThirdPartyClass(classId: $classId, members: $members) {
						id
						ownerId
					}
				}
			`,
			variables() {
				return {
					classId: this.selectedClass.id,
					members: [],
				}
			},
			fetchPolicy: "no-cache",
			update(r) {
				return r.ThirdPartyClass.ownerId;
			}
		},
	}
};
</script>
